import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCurrentUser, getUserUID, getFilteredUserUIDs } from '../selectors';
import QuizHeaderMenu from './QuizHeaderMenu';
import logo from '../images/Forester_logo.svg';
import '../styles/QuizHeader.css';

const QuizHeader = ({
  loggedIn,
  dispatch,
  userUID,
  users,
  currentUser,
}) => (
  <div className="QuizHeader fixed h3 w-100 flex items-center bb b--light-gray bg-white">
    <div className="flex items-center justify-between mw-100 mw7-ns w-100 center">
      <div className="mw5">
        <Link to="/quiz/">
          <img alt="Forester" src={logo} className="h1" />
        </Link>
      </div>
      <div className="login pr3 flex items-center">
        {loggedIn && (
          <QuizHeaderMenu />
        )}
      </div>
    </div>
  </div>
);


function mapStateToProps(state, ownProps) {
  return {
    loggedIn: state.loggedIn,
    checkedAuth: state.checkedAuth,
    currentUser: getCurrentUser(state, ownProps),
    users: getFilteredUserUIDs(state, ownProps),
    userUID: getUserUID(state, ownProps),
  };
}

export default connect(mapStateToProps)(QuizHeader);



// WEBPACK FOOTER //
// ./src/components/QuizHeader.js